// src/components/user/ProjectCard.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { FaCalendar, FaMapMarker, FaBuilding, FaArrowRight } from 'react-icons/fa';

const ProjectCard = ({ project }) => {
  // Format dates for display
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
      {/* Project Image */}
      {project.images && project.images[0] && (
        <div className="h-56 overflow-hidden">
          <img 
            src={project.images[0]} 
            alt={project.title}
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
          />
        </div>
      )}

      {/* Project Info */}
      <div className="p-6">
        <div className="flex justify-between items-start mb-4">
          <div>
            <span className={`inline-block px-3 py-1 text-xs font-semibold rounded-full ${
              project.status === 'completed' ? 'bg-green-100 text-green-800' :
              project.status === 'ongoing' ? 'bg-yellow-100 text-yellow-800' :
              'bg-blue-100 text-blue-800'
            }`}>
              {project.status}
            </span>
            {project.category && project.category !== 'General' && (
              <span className="ml-2 inline-block px-3 py-1 text-xs bg-gray-100 text-gray-600 rounded-full">
                {project.category}
              </span>
            )}
          </div>
        </div>

        <h3 className="text-xl font-bold text-gray-800 mb-3">{project.title}</h3>
        <p className="text-gray-600 mb-4 line-clamp-3">{project.description}</p>

        {/* Project Details */}
        <div className="space-y-3 mb-6">
          {project.client_name && (
            <div className="flex items-center text-sm text-gray-500">
              <FaBuilding className="h-4 w-4 mr-2 text-blue-500" />
              <span>Client: {project.client_name}</span>
            </div>
          )}
          {project.location && (
            <div className="flex items-center text-sm text-gray-500">
              <FaMapMarker className="h-4 w-4 mr-2 text-red-500" />
              <span>Location: {project.location}</span>
            </div>
          )}
          {project.start_date && (
            <div className="flex items-center text-sm text-gray-500">
              <FaCalendar className="h-4 w-4 mr-2 text-green-500" />
              <span>
                {formatDate(project.start_date)} 
                {project.end_date && ` - ${formatDate(project.end_date)}`}
              </span>
            </div>
          )}
        </div>

        {/* View Details Link */}
        <Link 
          to={`/projects/${project.id}`}
          className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium"
        >
          View Project Details
          <FaArrowRight className="h-4 w-4 ml-2" />
        </Link>
      </div>
    </div>
  );
};

export default ProjectCard;